"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Controller instance attach one editor instance, could approach
// all api of the editor, also have format instance(such as bold/header)
// lifecycle
// TODO 为了编译不报错，下次有break-change可以去掉这个
var Controller = /** @class */ (function () {
    function Controller(editor, store, props) {
        this.name = ''; // format name
        this.eventHandler = null;
        this.keymap = null;
        this.transformGetHTML = null;
        this.editor = editor;
        this.store = store;
        this.props = props || {};
    }
    Controller.prototype.editorWillUnmount = function () {
        // destroy virtual function
    };
    return Controller;
}());
exports.Controller = Controller;
//# sourceMappingURL=controller.js.map